module.exports = __webpack_public_path__ + "img/google.1c8bbb37.png";